import useClinicalDataCount from '@hooks/query/life-id/useClinicalDataCount';
import {
  AlergiesIntoleranceOutlined,
  DiabetesDiaryOputlined,
  DiagnosisOutlined,
  FirstAidOutlined,
  LaboratoryResultsOutlined,
  MedicalRecordsOutlined,
  MedicationsOutlined,
  PerformanceDiaryOutlined,
  PregnancyDiaryOutlined,
  RadiologyOutlined,
} from '@icon';
import {
  ActionCard,
  ActionCardCountRight,
  ActionCardIconLeft,
  ActionCardTitleDesc,
  LifeIdDrawer,
} from '@ui';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import MedicalDataDrawer from '../medical-data-drawer';
import { ClinicalDataSC } from './clinical-data.styled';
import ReceiptsList from './components/receipts-list';

const INTERVAL = 1000 * 30;
interface ClinicalDataProps {
  clientId: string;
}

const ClinicalData: React.FC<ClinicalDataProps> = ({ clientId }) => {
  const { formatMessage } = useIntl();
  const [medicalDataDrawer, setMedicalDataDrawer] = useState(false);
  const { data: recordCount } = useClinicalDataCount(clientId, { refetchInterval: INTERVAL });

  const {
    open: openReceipts,
    close: closeReceipts,
    drawerProps: receiptsProps,
  } = LifeIdDrawer.useDrawer();

  return (
    <ClinicalDataSC>
      <ActionCard.Button onClick={() => setMedicalDataDrawer(true)}>
        <ActionCard
          left={<ActionCardIconLeft Icon={MedicalRecordsOutlined} />}
          right={
            <ActionCardCountRight showChevron>
              {recordCount?.medicalRecords ?? 0}
            </ActionCardCountRight>
          }
        >
          <ActionCardTitleDesc title={formatMessage({ id: 'med_records.medical_records' })} />
        </ActionCard>
      </ActionCard.Button>
      <ActionCard.Button onClick={() => openReceipts()}>
        <ActionCard
          left={<ActionCardIconLeft Icon={MedicationsOutlined} />}
          right={
            <ActionCardCountRight showChevron>{recordCount?.receipts ?? 0}</ActionCardCountRight>
          }
        >
          <ActionCardTitleDesc title={formatMessage({ id: 'med_records.receipts' })} />
        </ActionCard>
      </ActionCard.Button>
      <ActionCard.Button disabled>
        <ActionCard
          left={<ActionCardIconLeft Icon={AlergiesIntoleranceOutlined} />}
          right={
            <ActionCardCountRight showChevron>{recordCount?.allergies ?? 0}</ActionCardCountRight>
          }
        >
          <ActionCardTitleDesc title={formatMessage({ id: 'med_records.alergies_intolerance' })} />
        </ActionCard>
      </ActionCard.Button>
      <ActionCard.Button disabled>
        <ActionCard
          left={<ActionCardIconLeft Icon={DiagnosisOutlined} />}
          right={<ActionCardCountRight showChevron>0</ActionCardCountRight>}
        >
          <ActionCardTitleDesc title={formatMessage({ id: 'med_records.diagnosis' })} />
        </ActionCard>
      </ActionCard.Button>
      <ActionCard.Button disabled>
        <ActionCard
          left={<ActionCardIconLeft Icon={LaboratoryResultsOutlined} />}
          right={
            <ActionCardCountRight showChevron>
              {recordCount?.laboratoryResults ?? 0}
            </ActionCardCountRight>
          }
        >
          <ActionCardTitleDesc title={formatMessage({ id: 'med_records.laboratory_results' })} />
        </ActionCard>
      </ActionCard.Button>
      <ActionCard.Button disabled>
        <ActionCard
          left={<ActionCardIconLeft Icon={RadiologyOutlined} />}
          right={
            <ActionCardCountRight showChevron>{recordCount?.radiology ?? 0}</ActionCardCountRight>
          }
        >
          <ActionCardTitleDesc title={formatMessage({ id: 'med_records.radiology' })} />
        </ActionCard>
      </ActionCard.Button>
      <ActionCard.Button disabled>
        <ActionCard
          left={<ActionCardIconLeft Icon={FirstAidOutlined} />}
          right={
            <ActionCardCountRight showChevron>{recordCount?.firstAid ?? 0}</ActionCardCountRight>
          }
        >
          <ActionCardTitleDesc title={formatMessage({ id: 'med_records.first_aid' })} />
        </ActionCard>
      </ActionCard.Button>
      <ActionCard.Button disabled>
        <ActionCard
          left={<ActionCardIconLeft Icon={DiabetesDiaryOputlined} />}
          right={<ActionCardCountRight showChevron>{0}</ActionCardCountRight>}
        >
          <ActionCardTitleDesc title={formatMessage({ id: 'med_records.diabetes_diary' })} />
        </ActionCard>
      </ActionCard.Button>
      <ActionCard.Button disabled>
        <ActionCard
          left={<ActionCardIconLeft Icon={PregnancyDiaryOutlined} />}
          right={
            <ActionCardCountRight showChevron>
              {recordCount?.pregnancyDiary ?? 0}
            </ActionCardCountRight>
          }
        >
          <ActionCardTitleDesc title={formatMessage({ id: 'med_records.pregnancy_diary' })} />
        </ActionCard>
      </ActionCard.Button>
      <ActionCard.Button disabled>
        <ActionCard
          left={<ActionCardIconLeft Icon={PerformanceDiaryOutlined} />}
          right={
            <ActionCardCountRight showChevron>
              {recordCount?.pregnancyDiary ?? 0}
            </ActionCardCountRight>
          }
        >
          <ActionCardTitleDesc title={formatMessage({ id: 'med_records.performance_diary' })} />
        </ActionCard>
      </ActionCard.Button>
      <MedicalDataDrawer visible={medicalDataDrawer} onClose={() => setMedicalDataDrawer(false)} />
      <ReceiptsList clientId={clientId!} {...receiptsProps} onClose={closeReceipts} />
    </ClinicalDataSC>
  );
};

export default React.memo(ClinicalData);
